export default {
  SPACE_SUBSTITUTE: "'ר'ו'ח'", // for abbreviation expander
  DEFAULT_FONT_SIZE: 25,
  MAX_FONT_SIZE: 70,
  MIN_FONT_SIZE: 12,
  hideableColor: '#007EE5',
  alternateHideableColor: '#949494',
  cursorColor: '#9cd1ff'
}